import ChakraProvider from './ChakraProvider'
import ModalsProvider from './ModalsProvider'
import QueryClientProvider from './QueryClientProvider'
import RouterProvider from './RouterProvider'
import WagmiProvider from './WagmiProvider'
import WorkerProvider from './WorkerProvider'

export const Providers = ({ children }) => {
  return (
    <ChakraProvider>
      <WagmiProvider>
        <QueryClientProvider>
          <WorkerProvider>
            <ModalsProvider>
              <RouterProvider>{children}</RouterProvider>
            </ModalsProvider>
          </WorkerProvider>
        </QueryClientProvider>
      </WagmiProvider>
    </ChakraProvider>
  )
}

export default Providers
